import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  CardLinkingFidelCountries,
  CardLinkingQuery,
  CardLinkingService,
  CardLinkingSettings,
  FidelCallBack,
  FidelJsLoaderService,
  FidelLinkedCardError,
  FidelService,
  LinkedCard,
  MemberQuery,
  TermsAndConditionsType,
} from '@fgb/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Observable } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fgbcl-card-link-button',
  templateUrl: './card-link-button.component.html',
  styleUrls: ['./card-link-button.component.scss'],
})
export class CardLinkButtonComponent implements OnInit, OnDestroy {
  cardId: string;
  hideAddress: boolean = false;
  showCancelButton: boolean = false;
  fedilCallBack: FidelCallBack;
  modelContent: any;
  private _destroyed$ = new Subject<void>();
  linkedCardsCount$: Observable<number>;
  @Input() countries: CardLinkingFidelCountries[] = [CardLinkingFidelCountries.GBR];
  disableCardButton: boolean = false;
  /** Default card linking settings are set if no input is passed */
  @Input() cardLinkingSettings: CardLinkingSettings = {
    allowMultipleCardLinking: true,
  };

  isTermsAccepted: boolean = false;
  termsAndConditionsType = TermsAndConditionsType.PrivacyPolicy;

  constructor(
    private modalService: NgbModal,
    private fidelService: FidelService,
    private fidelJsLoaderService: FidelJsLoaderService,
    private memberQuery: MemberQuery,
    private cardLinkingService: CardLinkingService,
    private router: Router,
    private cardLinkingQuery: CardLinkingQuery
  ) {}

  ngOnInit(): void {
    this.linkedCardsCount$ = this.cardLinkingQuery.selectCount();
  }

  /**
   * This method will open terms modal prior to linking
   * a users card through fidel.
   * @param termsContent Terms Modal Content
   */
  openCardLinkingTerms(termsContent: any) {
    if (
      this.cardLinkingSettings.allowMultipleCardLinking === true ||
      (this.cardLinkingSettings.allowMultipleCardLinking === false && this.cardLinkingQuery.getCount() === 0)
    ) {
      this.modalService.open(termsContent, { windowClass: 'card-linking-terms-modal' }).result.then(
        () => {},
        (reason) => {
          if (reason === ModalDismissReasons.ESC || reason === ModalDismissReasons.BACKDROP_CLICK) {
            this.isTermsAccepted = false;
          }
        }
      );
    }
  }

  /**
   * open popup for linking the card.
   * retrun either error if there is an issue while linking or Card details if successfully linked.
   */
  linkcard() {
    if (this.isTermsAccepted) {
      this.cancel();
      this.disableCardButton = true;
      setTimeout(() => {
        return this.fidelJsLoaderService
          .loadJs()
          .pipe(delay(50), takeUntil(this._destroyed$))
          .subscribe((status) => {
            if (status == 'loaded') {
              this.cardLinkedStatus();
              this.fidelService.linkcard(this.memberQuery.getUserContext().memberId, {}, this.countries, this.fedilCallBack);
            }
          });
      }, 500);
    }
  }

  /**
   * Implementation of fedil callback function.
   * callbackSuccess will call when card successfully link and callbackFailed will call if there is any issue.
   * @param content to open the NgbModal for offers.
   */
  cardLinkedStatus() {
    this.fedilCallBack = {
      callbackSuccess: (card: LinkedCard) => {
        if (card) {
          setTimeout(() => {
            this.cardLinkingService.fetchFidelLinkedCard().toPromise();
            this.router.navigateByUrl('/linkcardSuccess');
          }, 1600);
        }
      },
      callbackFailed: (error: FidelLinkedCardError) => {
        if (error) {
        }
      },
    };
  }

  /**
   * open NgbModal for offers after successfully link the card.
   * callbackSuccess will call when card successfully link and callbackFailed will call if there is any issue.
   * @param content to open the NgbModal for offers.
   */
  openCardModal(): void {
    this.showCancelButton = false;
    this.hideAddress = false;
    this.modalService.open(this.modelContent, { ariaLabelledBy: 'modal-basic-title' });
  }

  /**
   * dismiss the offer model.
   */
  cancel(): void {
    this.isTermsAccepted = false;
    this.modalService.dismissAll();
  }

  /**
   * Unsubscribe the observables on distroy
   */
  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
